import { SeverityLevel } from "@microsoft/applicationinsights-web";
import { appInsights } from "appInsightsAuth";
import axios from "axios"
import { globalConfigUrl } from "Configuration/config";
import { toast } from "react-toastify";
import { toastConfig } from "../Components/Constants";

export const api = async() => {
    const response:any = await fetch(globalConfigUrl).then((response) => 
        response.json()
    ).then((data) => {
        return data;
    })
    const apiInstance = axios.create({
        baseURL: response.apiUrl
    });

    // registering the custom error handler
    apiInstance.interceptors.response.use(undefined, (error:any) => {
        return errorHandler(error)
    })
    return apiInstance;
}

// defining a custom error handler for all APIs
const errorHandler = (error:any) => {
    let message;
    const statusCode = error.response?.status
    if (error.code === "ERR_CANCELED") {
        appInsights.trackException({ error: error, severityLevel: SeverityLevel.Error });
        
        toast.error(message, { ...toastConfig, toastId: message + "-toast" });
        return Promise.resolve()
    }

    // logging only errors that are not 401
    if (statusCode && statusCode !== 401) {
        if (error.response.data.message) {
            message = error.response.data.message;
        }
        else {
            message = error.response.data;
        }
        appInsights.trackException({ error, severityLevel: SeverityLevel.Error });
        toast.error(message, { ...toastConfig, toastId: message + "-toast" });
    }

    return Promise.reject(error)
}